
interface simpleObj {
  id?: number;
  name?: string;
  code?: string;
  description?: string;
  image?: string;
  price?: number;
  category?: string;
  quantity?: number;
  inventoryStatus?: string;
  rating?: number;
}

export const picklistproducts: simpleObj[] = [
  {
    id: 1,
    code: 'f230fh0g3',
    name: 'Bamboo Watch 1',
    description: 'Product Description',
    price: 65,
    category: 'Accessories',
    quantity: 24,
    inventoryStatus: 'INSTOCK',
    rating: 5
  },
  {
    id: 2,
    code: 'f230fh0g3',
    name: 'Bamboo Watch 2',
    description: 'Product Description',
    price: 65,
    category: 'Accessories',
    quantity: 24,
    inventoryStatus: 'INSTOCK',
    rating: 5
  },
  {
    id: 3,
    code: 'f230fh0g3',
    name: 'Bamboo Watch 3',
    description: 'Product Description',
    price: 65,
    category: 'Accessories',
    quantity: 24,
    inventoryStatus: 'INSTOCK',
    rating: 5
  },
];

export const picklistproductsSelected: simpleObj[] = [
  {
    id: 2,
    code: 'f230fh0g3',
    name: 'Bamboo Watch 2',
    description: 'Product Description',
    price: 65,
    category: 'Accessories',
    quantity: 24,
    inventoryStatus: 'INSTOCK',
    rating: 5
  },
  {
    id: 3,
    code: 'f230fh0g3',
    name: 'Bamboo Watch 3',
    description: 'Product Description',
    price: 65,
    category: 'Accessories',
    quantity: 24,
    inventoryStatus: 'INSTOCK',
    rating: 5
  },
];
